import React, { useContext, useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import AppContext from '../context/AppContext';
import { AuthContext } from "../context/AuthContext";
import RequestReloadContext from '../context/RequestReloadContext';

const HandleUWEEntityUpdate = ({
    submitState,
    formDefinition,
    scope: { props: { slug } },
    formSubmitResult,
    forceGoBackToDashboard = false,
    pathToRedirect,
}) => {
    const forceGoBack = forceGoBackToDashboard || formDefinition.submitButtons[submitState].forceGoBackToDashboard
    const {isAnonymous} = useContext(AppContext);
    const navigate = useNavigate();
    const location = useLocation();
    const rrc = useContext(RequestReloadContext);
    const { data: { id, status, isOpen } } = formSubmitResult;
    const isNew = location.pathname.endsWith('new');
    const canWork = status?.some(x => x.canWork);
    const path = pathToRedirect || (slug ? (isNew && canWork && isOpen && !forceGoBackToDashboard  ? `/workflow/${slug}/${id}/` : `/workflow/${slug}/tray`) : '');

    useEffect(() => {
        if (isAnonymous) {
            navigate("/thankyou", { replace: true });
        } else if (!isNew && canWork && isOpen && !forceGoBack) {
            // Can continue the flow of the case
            if (rrc) {
                rrc.reload();
            } else {
                window.location.reload();
            }
        } else {
            navigate(path, { replace: true });
        }
    }, []);

    return <div>redirect to {path}</div>;
}

export default HandleUWEEntityUpdate;
